export type LegacyPackageDetail = {
  id: string
  type: string
  division: string
  name: string
  themeCount: number
}

export type LegacyPackageItem = {
  id: string
  statistics: string
  name: string
  amount: number
  hidden: boolean
  details: LegacyPackageDetail[]
}

export const legacyPackageGroups = Array.from({ length: 14 }, (_, index) => ({
  id: String(index + 1),
  name: `Mock 그룹 ${String(index + 1).padStart(2, '0')}`,
}))

const detailTypes = ['촬영', '앨범', '액자', '기타상품', '파일', '메이크업']

export const legacyPackageItems: LegacyPackageItem[] = Array.from({ length: 12 }, (_, packageIndex) => ({
  id: `PK-${String(packageIndex + 1).padStart(3, '0')}`,
  statistics: `Mock 통계 ${String((packageIndex % 4) + 1).padStart(2, '0')}`,
  name: `Mock 패키지 상품 ${String(packageIndex + 1).padStart(2, '0')}`,
  amount: 100000 + packageIndex * 25000,
  hidden: packageIndex > 9,
  details: Array.from({ length: packageIndex === 0 ? 6 : 3 }, (_, detailIndex) => ({
    id: `DP-${packageIndex + 1}-${detailIndex + 1}`,
    type: detailTypes[detailIndex % detailTypes.length],
    division: `Mock 상품구분 ${(detailIndex % 3) + 1}`,
    name: `Mock 상세상품 ${packageIndex + 1}-${detailIndex + 1}`,
    themeCount: (detailIndex % 3) + 1,
  })),
}))

export const legacyPackageProductPool = Array.from({ length: 24 }, (_, index) => ({
  id: `POOL-${String(index + 1).padStart(3, '0')}`,
  type: detailTypes[index % detailTypes.length],
  division: `Mock 상품구분 ${(index % 4) + 1}`,
  name: `Mock 등록 상품 ${String(index + 1).padStart(2, '0')}`,
  amount: 10000 + index * 1500,
  vendor: `Mock 제작업체 ${(index % 3) + 1}`,
}))

